import { BenefitLayout } from "providers/benefit-layout";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { Button, ButtonVariant } from "shared/components/Button";
import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";

export const SuccessView = ({
  monthsReviewed
}: {
  monthsReviewed: string[];
}) => {
  return (
    <BenefitLayout
      title=""
      footer={
        <div>
          <Link to="/hub">
            <Button
              className="w-full max-w-[440px] mx-auto"
              variant={ButtonVariant.PRIMARY}
            >
              Done
            </Button>
          </Link>
        </div>
      }
    >
      <div className="pb-6 max-w-[440px] mx-auto">
        <SuccessIcon width={40} height={40} className="mb-6 text-success-500" />
        <h1 className="text-content-1000 text-xl font-bold mb-6">
          You&apos;re all set! The following months have been reviewed
        </h1>

        <div className="mb-6 flex flex-col gap-3">
          {monthsReviewed.map((month) => (
            <div className="flex items-center gap-2" key={month}>
              <SuccessIcon
                width={20}
                height={20}
                className="text-success-500"
              />
              <p key={month} className="text-content-1000">
                {format(parseISO(month), "MMMM yyyy")}
              </p>
            </div>
          ))}
        </div>

        <p className="text-sm font-medium text-content-500">
          We'll let you know if there are any issues verifying your payments.
        </p>
      </div>
    </BenefitLayout>
  );
};
